import React, { useEffect, useState } from "react";
import { useSettingStore } from "../../redux/auth-store";

const GoogleCaptcha = () => {
  const SCRIPT_ID = "recaptcha-script";
  const { settings } = useSettingStore();
  const [isMounted, setIsMounted] = useState<boolean>(false);

  /**
   * App mounted hook
   */
  useEffect(() => {
    setIsMounted(true);
    return () => {
      if (isMounted) {
        removeReCaptcha();
      }
    };
  }, [isMounted]);

  useEffect(() => {
    if (settings.ENABLE_RECAPTCHA) {
      const script = document.getElementById(SCRIPT_ID);
      if (!script) {
        loadReCaptcha();
      }
    }
  }, [settings.ENABLE_RECAPTCHA]);

  /**
   * Load the captcha sdk
   */
  const loadReCaptcha = () => {
    const script = document.createElement("script");
    script.src = `https://www.recaptcha.net/recaptcha/api.js?render=${settings.RECAPTCHA_SITE_KEY}`;
    script.id = SCRIPT_ID;
    script.async = true;
    document.body.appendChild(script);
  };

  /**
   * Remove captcha and badge on unload
   */
  const removeReCaptcha = () => {
    const script = document.getElementById(SCRIPT_ID);
    if (script) {
      script.remove();
      const reCaptchaElements: HTMLCollection =
        document.getElementsByClassName("grecaptcha-badge");
      if (reCaptchaElements.length) {
        reCaptchaElements[0].remove();
      }
    }
  };

  return (
    <React.Fragment>
      {/* <div
        className="g-recaptcha"
        data-sitekey={settings.RECAPTCHA_SITE_KEY}
        data-action="LOGIN"
      ></div> */}
    </React.Fragment>
  );
};
export default GoogleCaptcha;
